exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-zh-404-tsx": () => import("./../../../src/pages/zh/404.tsx" /* webpackChunkName: "component---src-pages-zh-404-tsx" */),
  "component---src-templates-gallery-gallery-post-tsx": () => import("./../../../src/templates/gallery/gallery-post.tsx" /* webpackChunkName: "component---src-templates-gallery-gallery-post-tsx" */)
}

